// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AreaChartController from "./area_chart_controller"
application.register("area-chart", AreaChartController)

import BootstrapCarouselController from "./bootstrap_carousel_controller"
application.register("bootstrap-carousel", BootstrapCarouselController)

import CardImagePickerController from "./card_image_picker_controller"
application.register("card-image-picker", CardImagePickerController)

import ColumnChartController from "./column_chart_controller"
application.register("column-chart", ColumnChartController)

import ComboSelectController from "./combo_select_controller"
application.register("combo-select", ComboSelectController)

import ComponentContentCopyController from "./component_content_copy_controller"
application.register("component-content-copy", ComponentContentCopyController)

import ComponentSettingsController from "./component_settings_controller"
application.register("component-settings", ComponentSettingsController)

import CssClassesController from "./css_classes_controller"
application.register("css-classes", CssClassesController)

import CsvColumnSelectController from "./csv_column_select_controller"
application.register("csv-column-select", CsvColumnSelectController)

import CurrencyChartController from "./currency_chart_controller"
application.register("currency-chart", CurrencyChartController)

import FileMediaSelectorController from "./file_media_selector_controller"
application.register("file-media-selector", FileMediaSelectorController)

import GridItemsController from "./grid_items_controller"
application.register("grid-items", GridItemsController)

import HorizontalBarChartController from "./horizontal_bar_chart_controller"
application.register("horizontal-bar-chart", HorizontalBarChartController)

import IconGalleryController from "./icon_gallery_controller"
application.register("icon-gallery", IconGalleryController)

import IconPickerController from "./icon_picker_controller"
application.register("icon-picker", IconPickerController)

import ImagePickerController from "./image_picker_controller"
application.register("image-picker", ImagePickerController)

import ImagePickerOffcanvasController from "./image_picker_offcanvas_controller"
application.register("image-picker-offcanvas", ImagePickerOffcanvasController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import LineChartController from "./line_chart_controller"
application.register("line-chart", LineChartController)

import MenuToggleController from "./menu_toggle_controller"
application.register("menu-toggle", MenuToggleController)

import MusicFileSelectorController from "./music_file_selector_controller"
application.register("music-file-selector", MusicFileSelectorController)

import MusicUploadController from "./music_upload_controller"
application.register("music-upload", MusicUploadController)

import PieChartColumnSelectController from "./pie_chart_column_select_controller"
application.register("pie-chart-column-select", PieChartColumnSelectController)

import PieChartController from "./pie_chart_controller"
application.register("pie-chart", PieChartController)

import PlaylistPlayerController from "./playlist_player_controller"
application.register("playlist-player", PlaylistPlayerController)

import PoemGeneratorController from "./poem_generator_controller"
application.register("poem-generator", PoemGeneratorController)

import RadarChartController from "./radar_chart_controller"
application.register("radar-chart", RadarChartController)

import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ResizeObserverController from "./resize_observer_controller"
application.register("resize-observer", ResizeObserverController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SortableTableController from "./sortable_table_controller"
application.register("sortable-table", SortableTableController)

import StatusUpdaterController from "./status_updater_controller"
application.register("status-updater", StatusUpdaterController)

import TableClassesController from "./table_classes_controller"
application.register("table-classes", TableClassesController)

import TinymceController from "./tinymce_controller"
application.register("tinymce", TinymceController)

import TrackMetadataController from "./track_metadata_controller"
application.register("track-metadata", TrackMetadataController)

import TurboLightController from "./turbo_light_controller"
application.register("turbo-light", TurboLightController)
